// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1477":"44f97ec3","4048":"6d57f6f5","5397":"6d57f6f5","6021":"e30e3f06","7152":"6d57f6f5","9435":"34b6bc87"}[chunkId] + ".chunk.css";
};